import { render } from "./BarCode.vue?vue&type=template&id=2a32ace9&scoped=true&ts=true"
import script from "./BarCode.vue?vue&type=script&lang=ts"
export * from "./BarCode.vue?vue&type=script&lang=ts"

import "./BarCode.vue?vue&type=style&index=0&id=2a32ace9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a32ace9"]])

export default __exports__